import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgService from '../../svg/service.svg'
import { IconProps } from '../icon-props'

const ServiceIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgService
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-service', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default ServiceIcon
